export const name = 're-core-page-user-claim-promotion-reward'
export const component = 're-claim-promotion-reward'

import {factory} from '../../../../lib/page'

const props = {
  promotedUserId: {},
}
export default factory(name, {props, component})
